/**
 * Hardcoded Profile ID for the "Client" role.
 *
 * Mirrors the legacy `add_client_user_modal.js` value (`btoa('Profile:-2')`).
 * The Person-based mutations (`CreatePersonMutation`, `CreateProjectPersonClientMutation`)
 * tag new guest users with this profile so they land in the Client permission group.
 *
 * Lives here so all guest-user flows in `clients-page` share one source of truth
 * rather than duplicating the literal across containers.
 */
export const CLIENT_PROFILE_ID = btoa('Profile:-2');
